export enum AssetsStatus {
    All = 'all',
    WithModels = 'models',
    WithAlerts = 'alerts',
    WithIssues = 'issues',
}
